import { NavLink, useParams } from 'libs/router'
import { useTranslation } from 'libs/i18n'
import { CompactTable } from '@table-library/react-table-library/compact'
import { useTheme } from '@table-library/react-table-library/theme'
import { getTheme } from '@table-library/react-table-library/baseline'
import { ShoppingBagIcon } from '@heroicons/react/24/outline'
import { Spinner } from 'shared/atoms'
import { EmptyState } from 'shared/components/EmptyState/EmptyState'
import { getCardTableStyles } from 'styles/table'
import { routes } from 'config/routes'
import { useFetchSales } from './queries/useFetchSales'
import { useColumns } from './hooks/useColumns'
import { TableNode } from '@table-library/react-table-library'

const MAX_ROWS = 6

export const dashedEmptyClassName =
	'mt-4 min-h-0 rounded-md border border-dashed border-border bg-muted/40 px-4 py-8'

export const BookingSalesTable = () => {
	const { t } = useTranslation()
	const { sales, isSalesLoading } = useFetchSales()
	const params = useParams()
	const columns = useColumns()
	const theme = useTheme([getTheme(), getCardTableStyles(columns, { selectable: false })])
	const results = sales?.data?.results ?? []

	return (
		<section className="rounded-lg border border-border bg-card p-5 shadow-panel sm:p-6">
			<div className="flex items-center justify-between gap-3">
				<h2 className="font-display text-base font-semibold text-foreground">{t('Sales')}</h2>
				{results.length > 0 && (
					<NavLink
						className="text-[12px] font-semibold text-primary hover:underline"
						to={`${routes.saleIndex}?booking_id=${params.id}`}>
						{t('View all')}
					</NavLink>
				)}
			</div>
			{isSalesLoading ? (
				<div className="flex justify-center py-8">
					<Spinner />
				</div>
			) : results.length ? (
				<div className="mt-4 overflow-hidden rounded-md border border-border [&_table]:static">
					<CompactTable
						columns={columns}
						data={{ nodes: results.slice(0, MAX_ROWS) as unknown as TableNode[] }}
						theme={theme}
						layout={{ custom: true, horizontalScroll: true }}
					/>
				</div>
			) : (
				<EmptyState
					className={dashedEmptyClassName}
					icon={<ShoppingBagIcon />}
					text={t('No sales yet')}
					description={t('Sales made through this booking will appear here.')}
				/>
			)}
		</section>
	)
}
